export default "__VITE_ASSET__Cqv_iwr7__"